import { zSchema, schemes, depositRuleResponseSchema } from "@zeal/common";

export const getCompanyDepositRulesRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
});

export type TGetCompanyDepositRulesRequestSchema = zSchema.infer<
  typeof getCompanyDepositRulesRequestSchema
>;

export const getCompanyDepositRulesResponseSchema = zSchema.array(
  zSchema.object({
    ruleID: schemes.uuid(),
    companyID: schemes.companyID(),
    workerID: schemes.mongoObjectId(),
    rules: zSchema.array(depositRuleResponseSchema),
  })
);

export type TGetCompanyDepositRulesResponseSchema = zSchema.infer<
  typeof getCompanyDepositRulesResponseSchema
>;
